import { createSlice } from "@reduxjs/toolkit";

const createWidgetSlice = createSlice({
  name: "widgetCreate",
  initialState: {
    currentUser: null,
    isFetching: false,
    error: false
  },
  reducers: {
    createWidgetStart: (state) => {
      state.isFetching = true;
    },
    createWidgetSuccess: (state, action) => {
        state.isFetching = false;
        state.currentUser = action.payload
        state.error = false;
    },
    createWidgetFailure: (state) => {
        state.currentUser = null;
        state.isFetching = false;
        state.error = true;
    },
    widgetStart: (state) => {
      state.isFetching = true;
    },
    widgetSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    widgetFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    deleteStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteSuccess: (state, action) => {
      state.widget = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    deleteFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});


export const { createWidgetStart, createWidgetSuccess, createWidgetFailure, widgetFailure, widgetStart, widgetSuccess, deleteFailure, deleteStart, deleteSuccess } = createWidgetSlice.actions;
export default createWidgetSlice.reducer;